import { useMutation, useQueryClient } from 'react-query';
import * as config from "../../../app.config";
import { setHeaders } from "../../../utils/basic";
import { USER_MESSAGE } from "../../../actions/User";
import axios from "axios";
import { useDispatch } from "react-redux";

const mutatePostBatchData = async ({ apiData }) => {
    let apiUrl = `${config.ENDPOINTS["datalake"]}/qc/create_batch`;

    const response = await axios.post(apiUrl, apiData,
        {
            headers: setHeaders()
        });
    if (!response?.data) {
        throw new Error('Network response was not ok');
    }
    return response?.data;
};

const useMutateCreateBatch = () => {
    const queryClient = useQueryClient();
    const dispatch = useDispatch();
    const mutation = useMutation(mutatePostBatchData, {
        onSuccess: (apiData) => {
            //const { plate_name, batch_id } = data;
            queryClient.invalidateQueries("QCPlatelist");
            dispatch({
                type: USER_MESSAGE,
                msgType: "success",
                text: "Batch created successfully",
                key: crypto.randomUUID()
            });
        },
        onError: (error) => {
            queryClient.invalidateQueries("QCPlatelist");
            dispatch({
                type: USER_MESSAGE,
                msgType: "error",
                text: `${error?.response?.data?.data?.message}`,
                key: crypto.randomUUID()
            });
        },
    }
    );
    return mutation;
};

export default useMutateCreateBatch;